import { AxiosError } from 'utils/gql/axios/AxiosClient';
import { setSentryUser } from 'integrations/sentry/sentry';
import { GqlResponseError } from 'utils/gql/errors/GqlResponseError';
import { CustomTenantModel } from 'providers/Tenant/Tenant.types';
import { print } from 'graphql';
import { redirectManager } from 'utils/gql/redirectManager';
import { graphql } from './gql/gql';
import { get } from './rest-clients';
import { getSessionConfigForHTTPHeaders } from './authSessionForCode/sessionConfig';
import { assignGlobalDefaultHeaders } from './gql/axios/axiosUtils';
import { GetInitialInfoDocument } from 'src/providers/User/__generated__/GetInitialInfo.graphql';
import { AuthUser } from 'src/providers/User/AuthUserModels';
import './gql/axios/axiosUtils';
import { redirectToSetPassword } from 'utils/gql/redirectToPublicPage';
import { initSessionConfigForCode } from 'utils/authSessionForCode/initSessionConfigForCode';

export interface SystemInitParams {
  user: AuthUser;
  tenant: CustomTenantModel;
  sessionForCode: boolean;
}
// https://localhost:3000/bpe/settings/spend/invoices/blueprints/view/IBPD4f4d0e34-d349-4fa8-a4a4-9933c2a0949e
export async function initSystem(): Promise<SystemInitParams> {
  const params = new URLSearchParams(window.location.search);
  if (window.location.pathname.includes('set-password') && params.get('verificationCode')) {
    redirectToSetPassword(new URLSearchParams(window.location.search));
    return {} as SystemInitParams;
  }

  try {
    const code = params.get('code');
    if (code) {
      await initSessionConfigForCode(code);
      const sessionHeaders = getSessionConfigForHTTPHeaders();
      assignGlobalDefaultHeaders(sessionHeaders);
    }

    const selfResponse = await graphql<{ self: AuthUser }>(print(GetInitialInfoDocument));
    if (!selfResponse.data?.self.person.tenantCode) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw new GqlResponseError([{ message: 'No tenant code' }]);
    }
    redirectManager.redirectIfApplicable();
    setSentryUser({ id: selfResponse.data?.self.person.personUid });

    const tenantResponse = await get<CustomTenantModel>(`/tenants/${selfResponse.data?.self.person.tenantCode}`);

    localStorage.setItem('auth:logged-in', 'true');
    return {
      user: selfResponse.data.self,
      tenant: tenantResponse.data,
      sessionForCode: !!code
    };
  } catch (error) {
    const axiosError = error as AxiosError | GqlResponseError;
    // eslint-disable-next-line prefer-promise-reject-errors, @typescript-eslint/no-throw-literal
    throw axiosError;
  }
}
